import { Injectable } from '@angular/core';
import { BaseApiService } from '@ep/shared';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderService extends BaseApiService {
  private readonly orderEndpoint = `/v2/Orders`;

  findByMerchantId(merchantId: number, pageNumber: number, pageSize: number, query?: string): Observable<any> {
    const params: Record<string, string | number> = { pageNumber, pageSize };
    if (query) {
      params['query'] = query;
    }

    return this.get(`${this.orderEndpoint}/merchant/${merchantId}`, params).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
}
